/**
 * WordPress dependencies.
 */
import { __ } from "@wordpress/i18n";
import { Spinner, PanelBody, TextareaControl } from "@wordpress/components";
import { Fragment, useState, useEffect } from "@wordpress/element";

/**
 * Internal dependencies.
 */
import { getDbFileContent as dbUri, checkServiceRequest as check } from "./helpers-functions";

const Debug = () => {
	const [debugFileLoadStatus, setdebugFileLoadStatus] = useState(true);
	const [debugFileLoadContent, setdebugFileLoadContent] = useState(false);

	const [debugRequestStatus, setdebugRequestStatus] = useState("loading");
	const [debugRequestContent, setdebugRequestContent] = useState([]);

	//https://devtrium.com/posts/async-functions-useeffect
	useEffect(() => {
		dbUri(window.ahscUtils.const.duBugFile).then((r) => {
			setdebugFileLoadStatus(false);
			setdebugFileLoadContent(r);
		});
	}, []);

	const DebuFileContent = () => {
		if (true === debugFileLoadStatus) {
			return (
				<PanelBody className={["center"]}>
					<Spinner
						style={{
							height: "calc(4px * 20)",
							width: "calc(4px * 20)",
						}}
					/>
				</PanelBody>
			);
		}

		if (false === debugFileLoadStatus) {
			if (false !== debugFileLoadContent) {
				return (
					<PanelBody>
						<TextareaControl
							label={__("Purging Log Actions", "aruba-hispeed-cache")}
							value={debugFileLoadContent}
							rows="15"
							className={["log-list-field"]}
							readOnly={true}
						/>
					</PanelBody>
				);
			}
		}

		return (
			<PanelBody title={__("Purging Log Actions", "aruba-hispeed-cache")} className={["center"]}>
				<p>
					{__(
						"File not found. The log file is not created, or is removed automatically, if the WordPress debugging feature is not enabled.",
						"aruba-hispeed-cache"
					)}
				</p>
			</PanelBody>
		);
	};


	useEffect( () => {
		check().then((r) => {
			setdebugRequestStatus("loaded");

			if (Array.isArray(r)) {
				setdebugRequestContent(r);
				return;
			}

			setdebugRequestContent([
				__(
					"An unexpected error occurred, please check your browser console or try again later.",
					"aruba-hispeed-cache"
				),
			]);
		});
	}, []);

	const Checker = () => {
		if ("loading" === debugRequestStatus) {
			return (
				<Fragment>
					<PanelBody title={__("Service check in progress.", "aruba-hispeed-cache")}>
						<span class="center">
							<Spinner
								style={{
									height: "calc(4px * 20)",
									width: "calc(4px * 20)",
								}}
							/>
						</span>
					</PanelBody>
				</Fragment>
			);
		}

		if ("loaded" === debugRequestStatus) {
			return (
				<PanelBody title={__("Service check request headers.", "aruba-hispeed-cache")}>
					<dl>
						{debugRequestContent.map((info) =>
							Array.isArray(info) ? (
								<>
									<dt>{info[0]}</dt>
									<dd>{info[1]}</dd>
								</>
							) : (
								<>
									<dt>{info}</dt>
								</>
							)
						)}
					</dl>
				</PanelBody>
			);
		}
	};

	return (
		<Fragment>
			{<DebuFileContent />}
			{<Checker />}
		</Fragment>
	);

};



export default Debug;
